import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { DELETE_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';

export const useDeleteGlossary = () => {
  const queryClient = useQueryClient();

  const deleteGlossary = async (glossaryId: number) => {
    await Axios.delete(DELETE_URL(glossaryId.toString()).deleteGlossary);
  };

  return useMutation<void, AxiosError<BaseError>, number>(deleteGlossary, {
    onSuccess: () => {
      queryClient.invalidateQueries('glossaries');
    },
    useErrorBoundary: false
  });
};
